import React, { useMemo } from 'react'

import { useButtonCtrLabel } from 'common/builder/components/chart/FlowChart/hooks/useButtonCtrLabel'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

import * as styles from './ButtonCtr.styles'

interface ButtonCtrProps {
  button: FlowChartButton
  wrapperStyle?: React.CSSProperties
}

export const ButtonCtr = ({ button, wrapperStyle }: ButtonCtrProps) => {
  const ctrLabel = useButtonCtrLabel(button)

  const style = useMemo(
    () => ({
      ...styles.wrapper,
      ...(wrapperStyle || {}),
    }),
    [wrapperStyle],
  )

  if (!ctrLabel) {
    return null
  }

  return (
    <view style={style}>
      <view style={styles.ctrOverlay}>
        <richtext style={styles.ctrText} text={ctrLabel} />
      </view>
    </view>
  )
}
